import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

export const LoaderWrapper = styled(FlexColumn)`
    justify-content: center;
    align-items: center;
`;

export const TextWWrapper = styled(FlexColumn)`
    text-align: center;
`;

export const Title = styled.p`
    margin: 0 0 16px;
    ${setFontVariant("h5_2", colorsPalettes.carbon[500])};

    @media (max-height: 800px) {
        margin-bottom: 4px;
        ${setFontVariant("h6", colorsPalettes.carbon[500])};
    }
`;

export const SubTitle = styled.p`
    margin: 0 0 16px;
    ${setFontVariant("body1", colorsPalettes.carbon[300])};

    @media (max-height: 800px) {
        margin-bottom: 4px;
        ${setFontVariant("body2", colorsPalettes.carbon[300])};
    }
`;

export const LoaderGif = styled.img`
    width: 200px;
    height: 200px;

    @media (max-height: 800px) {
        width: 170px;
        height: 170px;
    }
`;
